import { useMemo } from "react";
import { AUTH_SOURCE } from "../constants/authSource";
import { useGlobalStore } from "../context/UserContext/userContext";

// React hook to get studyId from props, CRE user, or URL
// Priority: 1. propStudyId, 2. CRE user data, 3. URL parameter
export function useStudyId(propStudyId) {
  const authSource = useGlobalStore((state) => state.authSource);
  const creUser = useGlobalStore((state) => state.creUser);
  return useMemo(() => {
    if (propStudyId) return propStudyId;
    if (authSource === AUTH_SOURCE.CRE) {
      return creUser?.oUserStudy?.studyId || null;
    }
    const params = new URLSearchParams(window.location.search);
    return params.get("StudyId");
  }, [propStudyId, authSource, creUser]);
}
